import { IAssetDTO } from '@/dtos';
import {
  uploadCriteriaGroupAssetAPI,
  uploadCriteriaMovieAPI,
  uploadCriteriaThubmnailAPI,
} from '@/services/admin';

export const uploadCriteriaGroupAsset = async (
  critieriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  try {
    const terms = await uploadCriteriaGroupAssetAPI(critieriaGroupId, file, onProgress);
    return terms;
  } catch {
    throw 'Error uploading criteria group asset';
  }
};

export const uploadCriteriaThubmnail = async (
  critieriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  try {
    const terms = await uploadCriteriaThubmnailAPI(critieriaGroupId, file, onProgress);
    return terms;
  } catch {
    throw 'Error uploading criteria thumbnail';
  }
};

export const uploadCriteriaMovie = async (
  critieriaGroupId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  try {
    const terms = await uploadCriteriaMovieAPI(critieriaGroupId, file, onProgress);
    return terms;
  } catch {
    throw 'Error uploading criteria movie';
  }
};
